import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { processMarkdown } from '@core/tellent-assistant-util';

@Component({
  selector: 'tellent-assistant-text-part',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<div class="body" [innerHTML]="html()"></div>`,
  styleUrl: './text-part.component.less',
})
export class TellentAssistantTextPartComponent {
  private readonly sanitizer = inject(DomSanitizer);

  protected readonly html = computed<SafeHtml>(() =>
    // eslint-disable-next-line ban/ban -- content passes through processMarkdown which sanitizes via marked
    this.sanitizer.bypassSecurityTrustHtml(processMarkdown(this.content())),
  );

  public readonly content = input.required<string>();
  public readonly done = input.required<boolean>();
}
